import Vue from "vue";
import VueRouter from "vue-router";
import route from "./route";

Vue.use(VueRouter);

// 配置路由
const routerConfig = {
    mode: "history",
    routes: route,
};

// 定义路由
const router = new VueRouter(routerConfig);

// 设置路由
router.beforeEach((to, from, next) => {
    /* ------------------------------------ 操控路由 ------------------------------------ */
    if(to.matched.length != 0){
        next();
    }else{
        next("/home");
    }
});

router.afterEach(() => {
    window.scrollTo(0, 0);
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js


// WEBPACK FOOTER //
// ./src/router/index.js